import {
	useMutation,
	type UseMutationResult,
} from "@tanstack/react-query";
import {
	getStudyCourseUpcomingSubscription,
	getStudyWebinarUpcomingSubscription,
} from "@/api/api";
import type { StudyWorkshopDetails } from "@/api/studyWorkshopDetails.types";

/**
 * Hook for subscribing to an upcoming webinar.
 * Sends a reminder email for the webinar event.
 */
export const useWebinarSubscription = (): UseMutationResult<
	StudyWorkshopDetails | undefined,
	Error,
	string
> => {
	return useMutation<StudyWorkshopDetails | undefined, Error, string>({
		mutationKey: ["webinar-subscription"],
		mutationFn: (slug: string) => getStudyWebinarUpcomingSubscription(slug),
	});
};

/**
 * Hook for subscribing to an upcoming course.
 * Sends a reminder email for the course event.
 */
export const useCourseSubscription = (): UseMutationResult<
	StudyWorkshopDetails | undefined,
	Error,
	string
> => {
	return useMutation<StudyWorkshopDetails | undefined, Error, string>({
		mutationKey: ["course-subscription"],
		mutationFn: (slug: string) => getStudyCourseUpcomingSubscription(slug),
	});
};

